import { create } from 'zustand';

import { User } from '@lib/user/definitions';

/**
 * `UserState` is an interface defining the state and actions for managing seller-related data.
 * This state stores shop information and provides a function to update it.
 *
 * - `user`: The seller's shop details, which may be undefined initially.
 * - `setUser`: Function to update the `user` state, allowing modifications to the shop details.
 */
interface UserState {
  user?: User;
  setUser: (user?: User) => void;
}

/**
 * `useSellerStore` is a Zustand store for managing seller-related state.
 * It tracks the seller's shop information and provides a function to update it.
 *
 * This store allows for:
 * - Storing and retrieving `user`, which holds the seller’s shop details.
 * - Providing `setUser`, a function to update `user` with new values.
 */
const useUserStore = create<UserState>((set) => ({
  setUser: (user?: User) => set({ user }),
}));

export { useUserStore };
